import { describe, it, expect } from 'vitest';
import { formatIban, maskInput } from './format-input';

describe(formatIban, () => {
  it('handles when IBAN is not defined', () => {
    const result = formatIban(undefined, false);
    expect(result).toBeUndefined();
  });

  it('formats a raw IBAN', () => {
    const iban = 'fr2914508000409376584625B97';
    const isIBANObfuscated = false;

    const result = formatIban(iban, isIBANObfuscated);

    expect(result).toBe('FR29 1450 8000 4093 7658 4625 B97');
  });

  it('formats a formatted IBAN', () => {
    const iban = 'FR29 1450 8000 4093 7658 4625 B97';
    const isIBANObfuscated = false;

    const result = formatIban(iban, isIBANObfuscated);

    expect(result).toBe('FR29 1450 8000 4093 7658 4625 B97');
  });

  it('formats a raw IBAN with non-alphanumeric chars', () => {
    const iban = 'FR 29 145!0_80004093-7658   4625 B97';
    const isIBANObfuscated = false;

    const result = formatIban(iban, isIBANObfuscated);

    expect(result).toBe('FR29 1450 8000 4093 7658 4625 B97');
  });

  it('formats an obfuscated IBAN with X', () => {
    const iban = 'XXxX1450XXXX4093xxX84625X97x';
    const isIBANObfuscated = true;

    const result = formatIban(iban, isIBANObfuscated);

    expect(result).toBe('•••• 1450 •••• 4093 •••8 4625 •97•');
  });

  it('formats an obfuscated IBAN when isIBANObfuscated is false', () => {
    const iban = 'XXxX1450XXXX4093xxX84625X97x';
    const isIBANObfuscated = false;

    const result = formatIban(iban, isIBANObfuscated);

    expect(result).toBe('XXXX 1450 XXXX 4093 XXX8 4625 X97X');
  });

  it('formats an obfuscated IBAN with dot', () => {
    const iban = '••••••••••••••••••••9241Z05';
    const isIBANObfuscated = true;

    const result = formatIban(iban, isIBANObfuscated);

    expect(result).toBe('•••• •••• •••• •••• •••• 9241 Z05');
  });

  it('formats an IBAN longer than 34 chars', () => {
    const iban = 'IT64B0300203280586761342825GHJK787800';
    const isIBANObfuscated = false;

    const result = formatIban(iban, isIBANObfuscated);

    expect(result).toBe('IT64 B030 0203 2805 8676 1342 825G HJK7 87');
  });
});

describe(maskInput, () => {
  it('masks a raw IBAN', () => {
    const iban = 'FR2914508000409376584625B97';
    const result = maskInput(iban);

    expect(result).toBe('FR29XXXXXXXXXXXXXXXXXXXXB97');
  });

  it('masks a raw IBAN with options', () => {
    const iban = 'FR2914508000409376584625B97';
    const result = maskInput(iban, '•', 2, 3);

    expect(result).toBe('FR••••••••••••••••••••••B97');
  });

  it('masks a raw IBAN already formatted', () => {
    const iban = 'FR29 1450 8000 4093 7658 4625 B97';
    const result = maskInput(iban);

    expect(result).toBe('FR29XXXXXXXXXXXXXXXXXXXXB97');
  });
});

describe('formatIban with maskInput', () => {
  it('masks and formats a raw IBAN', () => {
    const iban = 'BE21561839151703';
    const result = formatIban(maskInput(iban), false);

    expect(result).toBe('BE21 XXXX XXXX X703');
  });
});
